import 'mdn-polyfills/NodeList.prototype.forEach';

export default class Quiz {
  constructor(element) {
    this.element = element;
    this.score = 0;
    this.inputs = this.element.querySelectorAll(".c-question__input");
    this.answer = document.querySelectorAll(".c-question__answer");
    this.submitButton = document.querySelector(".js-button-submit");
    this.scoreBox = document.querySelector(".js-score");
    this.sectionStart = document.querySelector(".c-score__start");
    this.sectionEnd = document.querySelector(".c-score__end");
    this.scoreLabel = document.querySelector(".c-score__score__label");
    this.scoreFeedback = document.querySelector(".c-score__score__feedback");
    this.scoreExplication = document.querySelector(".c-score__condition");

    this.changeInput = this.changeInput.bind(this);
    this.submit = this.submit.bind(this);

    this.scoreText = [
      {
        "score": 0,
        "text": "Bon, et bien le moins que l’on puisse dire c’est que vous avez bien fait de venir ici, vous avez tout ce qu’il faut désormais pour comprendre tout ce qui peut être rapidement amélioré afin d’optimiser l’empreinte de votre site. Nous sommes d’ailleurs à <a href='http://www.lunaweb.fr/contact' target='_blank'>votre disposition</a> pour en discuter au besoin."
      },
      {
        "score": 3,
        "text": "C’est un début, il reste pas mal de points à optimiser afin d’atteindre une performance satisfaisante, vous avez en tout cas les cartes en main pour commencer à progresser sur le chemin de la sobriété numérique ! Au besoin, nous sommes d’ailleurs à <a href='http://www.lunaweb.fr/contact' target='_blank'>votre disposition</a> pour en discuter."
      },
      {
        "score": 5,
        "text": "Pas mal, vous avez déjà quelques points importants dans le vert ! Il ne vous reste donc plus qu’à vous lancer dans les autres optimisations afin de pouvoir rapidement améliorer votre empreinte numérique. Et n’oubliez pas : ce qui est bon pour l’éco-conception est excellent pour le référencement naturel comme l’expérience utilisateur !"
      },
      {
        "score": 6,
        "text": "Chouette, félicitations ! Vous bénéficiez d’une première approche vertueuse avec plusieurs points dans le vert, c’est un excellent début et cela doit vous encourager à aller encore plus loin car la base est solide ! Vous pouvez donc poursuivre sur le chemin de la sobriété et durabilité en réalisant un audit plus poussé et en modifiant les points restés dans le rouge. bien entendu, <a href='http://www.lunaweb.fr/contact' target='_blank'>nous sommes là</a> au besoin."
      },
      {
        "score": 8,
        "text": "BRAVO ! Il est encore très rare de disposer d’un tel score pour un site qui n’a pas été nativement écoconçu, voilà de quoi fanfaronner légitimement mais aussi (et surtout) de continuer d'optimiser votre site et plus largement votre écosystème numérique (avez-vous entendu parler des <a href='https://www.lunaweb.fr/blog/usage-core-web-vitals-pour-optimiser-ux-site/'>Core Web Vitals</a> ?)."
      }
    ]
    

  }

  mount() {
    this.inputs.forEach(element => {
      element.addEventListener('change', this.changeInput);
    });
    this.submitButton.addEventListener('click', this.submit);
  }

  changeInput(event) {
    let count = 0;
    this.inputs.forEach(element => {
      if( element.checked ) {
        count++;
      }
    });

    if (count<10) {
      if(this.scoreExplication.classList.contains("is-hidden")) {
        this.scoreExplication.classList.remove("is-hidden");
      }
      this.submitButton.disabled = true;
    } else {
      this.scoreExplication.classList.add("is-hidden");
      this.submitButton.disabled = false;
    }

    let questionGroupId = event.target.getAttribute("data-question-groupe");
    let questionAnswer = event.target.getAttribute("data-question-answer");
    this.answer[questionGroupId - 1].innerText = questionAnswer;

    if (event.target.getAttribute("data-question-score") == "1") {
      this.answer[questionGroupId - 1].style.color="#277925"
    } else {
      this.answer[questionGroupId - 1].style.color="#DE332E"
    }
    if(event.target.getAttribute("id")  == (questionGroupId+"-3")) {
      this.answer[questionGroupId - 1].style.color="#000"
    }
  }

  submit() {
    this.inputs.forEach(element => {
      if( element.checked ) {
        this.score = (this.score) + parseInt(element.getAttribute("data-question-score"));
      }
    });


      this.sectionStart.style.display="none";
      this.sectionEnd.style.display="block";
      this.scoreBox.innerText=this.score;
  
      if(this.score>1){
        this.scoreLabel.innerHTML="éléments éco-conçus"
      }else {
        this.scoreLabel.innerHTML="élément éco-conçu";
      }
  
  
      switch (true) {      
        case (this.score >= 8):
          this.scoreFeedback.innerHTML= this.scoreText[4].text
          break;
        case (this.score >= 6):
          this.scoreFeedback.innerHTML= this.scoreText[3].text
          break;
        case (this.score >=  5):
          this.scoreFeedback.innerHTML= this.scoreText[2].text
          break;
        case (this.score >=  3):
          this.scoreFeedback.innerHTML= this.scoreText[1].text
          break;
        case (this.score >= 0):
          this.scoreFeedback.innerHTML= this.scoreText[0].text
          break;
      }
      
  }


  unmount() {
  }
}
